class LinkDropdown extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('#filter-by');
    this.blogUrl = this.select.dataset.blogUrl;

    this.select.addEventListener('change', this.onSelectChange.bind(this));
  }

  onSelectChange() {
    const anchor = this.select.dataset.resultsAnchor;
    const suffix = anchor ? `#${encodeURIComponent(anchor)}` : '';
    if (this.select.value.length > 0) {
      window.location.href = this.blogUrl + '/tagged/' + encodeURIComponent(this.select.value) + suffix;
    }
    else window.location.href = this.blogUrl + suffix;
  }
}

customElements.define("link-dropdown", LinkDropdown);
